import React, { useEffect, useRef, useState } from "react";
import { productTypeValues } from "../../../utils/constants";

const ProductTypeSelector = ({
  value,
  onChange,
  readOnly = false,
  isError = false,
  errorMessage = "",
  label = "Type",
  labelClassName = "block text-black-lose text-[13px] font-medium mb-2",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelectOption = (option) => {
    if (readOnly) return;
    if (onChange) {
      onChange(option);
    }
    setIsOpen(false);
  };

  return (
    <div className="w-full relative" ref={dropdownRef}>
      {label && (
        <label className={labelClassName}>
          {label}
        </label>
      )}

      {/* Trigger Button */}
      <button
        type="button"
        disabled={readOnly}
        onClick={() => !readOnly && setIsOpen(!isOpen)}
        className={`w-full min-h-[42px] px-3.5 py-2 rounded-[8px] border flex items-center justify-between transition-all text-left shadow-2xs ${
          isError ? "border-orange-500 bg-white" : "border-primary-200 bg-white"
        } ${
          readOnly
            ? "bg-primary-50 text-gray-500 cursor-not-allowed border-primary-100"
            : "hover:border-primary-400 cursor-pointer"
        }`}
      >
        <span
          className={`text-[13px] font-medium truncate ${
            value ? "text-primary-700 font-semibold" : "text-gray-400 italic font-normal"
          }`}
        >
          {value || "Select Product Type..."}
        </span>
        <svg
          className={`w-4 h-4 text-primary-400 shrink-0 ml-2 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Custom Popup Dropdown */}
      {isOpen && !readOnly && (
        <div className="absolute left-0 right-0 top-full mt-1 bg-white border border-primary-200 rounded-[8px] shadow-xl z-50 p-1.5 max-h-[250px] overflow-y-auto">
          <div className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider px-2.5 py-1 mb-1 border-b border-gray-100">
            Select Type
          </div>
          {productTypeValues?.map((option) => {
            const isSelected = value === option;
            return (
              <button
                key={option}
                type="button"
                onClick={() => handleSelectOption(option)}
                className={`w-full text-left px-3 py-2 text-[13px] rounded-[6px] flex items-center justify-between transition-colors my-0.5 ${
                  isSelected
                    ? "bg-primary-50 text-primary-700 font-semibold"
                    : "text-gray-700 hover:bg-primary-50/60 hover:text-primary-800 font-medium"
                }`}
              >
                <span>{option}</span>
                {isSelected && (
                  <svg className="w-4 h-4 text-primary-600 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      )}

      {isError && errorMessage && (
        <div className="text-orange-800 text-[11px] uppercase mt-1 font-medium">
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default ProductTypeSelector;
